<template>
    <progress-bar :diameter="diameter" :completed-steps="completedSteps" :total-steps="totalSteps" timingFunc="ease-in">
        <template v-slot:tip>
            <div class="text-center">
                {{ Number(completedSteps) }}%
            </div>
        </template>
    </progress-bar>
</template>

<script>
import ProgressBar from "vue2-progress-bar";

export default {
    data() {
        return {

        };
    },
    components: {
        ProgressBar
    },
    props: {
        diameter: {
            type: Number,
            default: 200
        },
        completedSteps: {
            type: [Number, String],
            default: 0
        },
        totalSteps: {
            type: Number,
            default: 100
        }
    }
};
</script>
<style>
.progress-bar {
    background-color: transparent;
}
</style>
